import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { api } from '../lib/api';
import { Button } from '../components/common/Button';
import { LoadingSpinner } from '../components/common/LoadingSpinner';
import { SectionLabel } from '../components/common/SectionLabel';
import { ProjectList } from '../components/dashboard/ProjectList';

export function DashboardPage() {
  const navigate = useNavigate();
  const { data: projects, isLoading, error } = useQuery({
    queryKey: ['projects'],
    queryFn: api.getProjects,
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-24">
        <LoadingSpinner message="Loading initiatives..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-24">
        <p className="text-red-500 mb-4">Failed to load initiatives</p>
        <Button variant="secondary" onClick={() => window.location.reload()}>
          Try Again
        </Button>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-start justify-between mb-8">
        <div>
          <SectionLabel>Initiative Pipeline</SectionLabel>
          <h1 className="text-3xl font-bold text-white">Active Initiatives</h1>
        </div>
        <Button onClick={() => navigate('/submit')}>
          <Plus className="w-4 h-4 mr-2" />
          Submit Idea
        </Button>
      </div>

      {projects && projects.length > 0 ? (
        <ProjectList projects={projects} />
      ) : (
        <div className="text-center py-24 bg-wolf-900/30 border border-wolf-700/50">
          <p className="text-wolf-500 mb-4">No initiatives yet</p>
          <Button onClick={() => navigate('/submit')}>
            <Plus className="w-4 h-4 mr-2" />
            Submit Your First Idea
          </Button>
        </div>
      )}
    </div>
  );
}
